import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SuccessCenterTasksListDto } from '../../dto/success-center-tasks-list.dto';
import { BaseApiService } from 'src/app/shared/services/api';
import { PipelineGrowthDigestDto } from '../../dto';

@Injectable({
  providedIn: 'root'
})
export class SuccessCenterApiService {
    
  private readonly url: string = "service/success-center/email/settings";

  constructor(
    private baseApiService: BaseApiService
  ) { }

  getTasksList(): Observable<SuccessCenterTasksListDto> {
    return this.baseApiService.get<SuccessCenterTasksListDto>('service/success-center/status');
  }


    getPipelineGrowthDigestSettings(): Observable<PipelineGrowthDigestDto> {
        return this.baseApiService.get<PipelineGrowthDigestDto>(`${this.url}`);
    }

    getEmailFilteredList(emailInput: string): Observable<string[]> {
        return this.baseApiService.get<string[]>(`${this.url}/email-addresses/search`, {params: {emailContains : emailInput}, showError: true});
    }

    postEmailSettings(payload: PipelineGrowthDigestDto): Observable<PipelineGrowthDigestDto> {
        return this.baseApiService.post<PipelineGrowthDigestDto>(`${this.url}`, payload, {showError: true})
    }
}
